import { observable } from 'mobx';

class NotificationsStore {
  @observable errorMsg = ''
  @observable succesMsg = ''

  setErrorMsg = err => {
    this.errorMsg = err
    setTimeout( () => this.errorMsg = '', 1)
  }

  setSuccesMsg = err => {
    this.succesMsg = err
    setTimeout( () => this.succesMsg = '', 1)
  }
}

export default new NotificationsStore();